module.exports = __webpack_public_path__ + "img/mastercard.02f397a3.svg";